import React, { useRef, useState } from "react";
import "./index.css";
import copyClipboard from "../../../assets/GeneralIcons/copy_clipboard.svg";
import Close from "../../../assets/CloseIcons/close_with_blue_square.svg";

const DeviceTokenPopup = ({ onClose, token, isPopupOpen }) => {
  const [isCopied, setIsCopied] = useState(false);
  const tokenRef = useRef(null);

  const copyToClipboard = async (code) => {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(code);
        (() => {})();
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (e) {
        (() => {})();
      }
    }
  };

  const handleCopyClick = () => {
    const tokenText = tokenRef.current.innerText;
    copyToClipboard(tokenText);
  };

  const handleBackgroundClick = (e) => {
    if (e.target.className === "device-mainPopup") {
      onClose();
    }
  };

  return (
    <div className="device-mainPopup" onClick={handleBackgroundClick}>
      <div className="token-popup" onClick={(e) => e.stopPropagation()}>
        <div className="token-detail-text">
          <h5>Token Details</h5>
          <img
            src={Close}
            alt="Close"
            className="w-[30px] h-[30px] cursor-pointer"
            onClick={() => onClose()}
          />
        </div>

        <div className="api-box flex gap-5">
          <p ref={tokenRef} id="id-firstLetter">
            {token}
          </p>
          <div className="clipboard-img flex flex-shrink-0 items-end">
            <img
              src={copyClipboard}
              alt="copy clipboard"
              onClick={handleCopyClick}
            />
            {isCopied && <span className="copied-notification">Copied!</span>}
          </div>
        </div>

        <span className="text-Primary_grey text-sm">
          Please copy this token as it will not be shown again. <br />
          In case this token is misplaced, a new token must be generated.
        </span>
      </div>
    </div>
  );
};

export default DeviceTokenPopup;
